export default [
  {
    path: '/active-get-coupons/index',
    name: 'index',
    component: () => import('@/views/active-get-coupons/index'),
    meta: {
      title: ''
    }
  },
  
]
